import { render, staticRenderFns } from "./bandmenu.vue?vue&type=template&id=f2be47e6&scoped=true"
import script from "./bandmenu.vue?vue&type=script&lang=js"
export * from "./bandmenu.vue?vue&type=script&lang=js"
import style0 from "./bandmenu.vue?vue&type=style&index=0&id=f2be47e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be47e6",
  null
  
)

export default component.exports